import { SupportedShipBobWebhookTopics } from '../action-auto-trigger.js'

/** ShipBob Marketplace API (`2026-01`) webhook topics (`Webhooks.Topics`). */
export const SHIPBOB_API_WEBHOOK_TOPIC_ORDER_SHIPPED = 'order.shipped'
export const SHIPBOB_API_WEBHOOK_TOPIC_ORDER_SHIPMENT_CANCELLED = 'order.shipment.cancelled'
export const SHIPBOB_API_WEBHOOK_TOPIC_ORDER_SHIPMENT_DELIVERED = 'order.shipment.delivered'
export const SHIPBOB_API_WEBHOOK_TOPIC_ORDER_DELIVERED = 'order.delivered'
export const SHIPBOB_API_WEBHOOK_TOPIC_ORDER_SHIPMENT_EXCEPTION = 'order.shipment.exception'
export const SHIPBOB_API_WEBHOOK_TOPIC_ORDER_SHIPMENT_ON_HOLD = 'order.shipment.on_hold'
export const SHIPBOB_API_WEBHOOK_TOPIC_ORDER_SHIPMENT_TRACKING_UPDATED =
  'order.shipment.tracking.updated'
export const SHIPBOB_API_WEBHOOK_TOPIC_WRO_CREATED = 'wro.created'
export const SHIPBOB_API_WEBHOOK_TOPIC_WRO_UPDATED = 'wro.updated'
export const SHIPBOB_API_WEBHOOK_TOPIC_WRO_COMPLETED = 'wro.completed'
export const SHIPBOB_API_WEBHOOK_TOPIC_WRO_BOX_ARRIVED = 'wro.box.arrived'
export const SHIPBOB_API_WEBHOOK_TOPIC_WRO_BOX_SCANNED = 'wro.box.scanned'
export const SHIPBOB_API_WEBHOOK_TOPIC_WRO_BOX_STOWED = 'wro.box.stowed'

const API_TOPIC_BY_INTERNAL: Record<SupportedShipBobWebhookTopics, string> = {
  [SupportedShipBobWebhookTopics.ORDER_SHIPPED]: SHIPBOB_API_WEBHOOK_TOPIC_ORDER_SHIPPED,
  [SupportedShipBobWebhookTopics.ORDER_SHIPMENT_CANCELLED]:
    SHIPBOB_API_WEBHOOK_TOPIC_ORDER_SHIPMENT_CANCELLED,
  [SupportedShipBobWebhookTopics.ORDER_SHIPMENT_DELIVERED]:
    SHIPBOB_API_WEBHOOK_TOPIC_ORDER_SHIPMENT_DELIVERED,
  [SupportedShipBobWebhookTopics.ORDER_DELIVERED]: SHIPBOB_API_WEBHOOK_TOPIC_ORDER_DELIVERED,
  [SupportedShipBobWebhookTopics.ORDER_SHIPMENT_EXCEPTION]:
    SHIPBOB_API_WEBHOOK_TOPIC_ORDER_SHIPMENT_EXCEPTION,
  [SupportedShipBobWebhookTopics.ORDER_SHIPMENT_ON_HOLD]:
    SHIPBOB_API_WEBHOOK_TOPIC_ORDER_SHIPMENT_ON_HOLD,
  [SupportedShipBobWebhookTopics.ORDER_SHIPMENT_TRACKING_UPDATED]:
    SHIPBOB_API_WEBHOOK_TOPIC_ORDER_SHIPMENT_TRACKING_UPDATED,
  [SupportedShipBobWebhookTopics.WRO_CREATED]: SHIPBOB_API_WEBHOOK_TOPIC_WRO_CREATED,
  [SupportedShipBobWebhookTopics.WRO_UPDATED]: SHIPBOB_API_WEBHOOK_TOPIC_WRO_UPDATED,
  [SupportedShipBobWebhookTopics.WRO_COMPLETED]: SHIPBOB_API_WEBHOOK_TOPIC_WRO_COMPLETED,
  [SupportedShipBobWebhookTopics.WRO_BOX_ARRIVED]: SHIPBOB_API_WEBHOOK_TOPIC_WRO_BOX_ARRIVED,
  [SupportedShipBobWebhookTopics.WRO_BOX_SCANNED]: SHIPBOB_API_WEBHOOK_TOPIC_WRO_BOX_SCANNED,
  [SupportedShipBobWebhookTopics.WRO_BOX_STOWED]: SHIPBOB_API_WEBHOOK_TOPIC_WRO_BOX_STOWED,
}

/** Legacy 1.0/2.0 topic strings and normalized API aliases → internal enum. */
const INTERNAL_BY_INBOUND_TOPIC: Record<string, SupportedShipBobWebhookTopics> = {
  [SHIPBOB_API_WEBHOOK_TOPIC_ORDER_SHIPPED]: SupportedShipBobWebhookTopics.ORDER_SHIPPED,
  order_shipped: SupportedShipBobWebhookTopics.ORDER_SHIPPED,
  'order shipped': SupportedShipBobWebhookTopics.ORDER_SHIPPED,
  [SHIPBOB_API_WEBHOOK_TOPIC_ORDER_SHIPMENT_CANCELLED]:
    SupportedShipBobWebhookTopics.ORDER_SHIPMENT_CANCELLED,
  shipment_cancelled: SupportedShipBobWebhookTopics.ORDER_SHIPMENT_CANCELLED,
  'shipment cancelled': SupportedShipBobWebhookTopics.ORDER_SHIPMENT_CANCELLED,
  [SHIPBOB_API_WEBHOOK_TOPIC_ORDER_SHIPMENT_DELIVERED]:
    SupportedShipBobWebhookTopics.ORDER_SHIPMENT_DELIVERED,
  shipment_delivered: SupportedShipBobWebhookTopics.ORDER_SHIPMENT_DELIVERED,
  'shipment delivered': SupportedShipBobWebhookTopics.ORDER_SHIPMENT_DELIVERED,
  [SHIPBOB_API_WEBHOOK_TOPIC_ORDER_DELIVERED]: SupportedShipBobWebhookTopics.ORDER_DELIVERED,
  order_delivered: SupportedShipBobWebhookTopics.ORDER_DELIVERED,
  'order delivered': SupportedShipBobWebhookTopics.ORDER_DELIVERED,
  [SHIPBOB_API_WEBHOOK_TOPIC_ORDER_SHIPMENT_EXCEPTION]:
    SupportedShipBobWebhookTopics.ORDER_SHIPMENT_EXCEPTION,
  shipment_exception: SupportedShipBobWebhookTopics.ORDER_SHIPMENT_EXCEPTION,
  'shipment exception': SupportedShipBobWebhookTopics.ORDER_SHIPMENT_EXCEPTION,
  [SHIPBOB_API_WEBHOOK_TOPIC_ORDER_SHIPMENT_ON_HOLD]:
    SupportedShipBobWebhookTopics.ORDER_SHIPMENT_ON_HOLD,
  shipment_onhold: SupportedShipBobWebhookTopics.ORDER_SHIPMENT_ON_HOLD,
  'shipment onhold': SupportedShipBobWebhookTopics.ORDER_SHIPMENT_ON_HOLD,
  'shipment on hold': SupportedShipBobWebhookTopics.ORDER_SHIPMENT_ON_HOLD,
  [SHIPBOB_API_WEBHOOK_TOPIC_ORDER_SHIPMENT_TRACKING_UPDATED]:
    SupportedShipBobWebhookTopics.ORDER_SHIPMENT_TRACKING_UPDATED,
  'order.shipment.tracking updated': SupportedShipBobWebhookTopics.ORDER_SHIPMENT_TRACKING_UPDATED,
  [SHIPBOB_API_WEBHOOK_TOPIC_WRO_CREATED]: SupportedShipBobWebhookTopics.WRO_CREATED,
  wro_created: SupportedShipBobWebhookTopics.WRO_CREATED,
  'wro created': SupportedShipBobWebhookTopics.WRO_CREATED,
  [SHIPBOB_API_WEBHOOK_TOPIC_WRO_UPDATED]: SupportedShipBobWebhookTopics.WRO_UPDATED,
  wro_updated: SupportedShipBobWebhookTopics.WRO_UPDATED,
  'wro updated': SupportedShipBobWebhookTopics.WRO_UPDATED,
  [SHIPBOB_API_WEBHOOK_TOPIC_WRO_COMPLETED]: SupportedShipBobWebhookTopics.WRO_COMPLETED,
  wro_completed: SupportedShipBobWebhookTopics.WRO_COMPLETED,
  'wro completed': SupportedShipBobWebhookTopics.WRO_COMPLETED,
  [SHIPBOB_API_WEBHOOK_TOPIC_WRO_BOX_ARRIVED]: SupportedShipBobWebhookTopics.WRO_BOX_ARRIVED,
  wro_box_arrived: SupportedShipBobWebhookTopics.WRO_BOX_ARRIVED,
  'wro box arrived': SupportedShipBobWebhookTopics.WRO_BOX_ARRIVED,
  [SHIPBOB_API_WEBHOOK_TOPIC_WRO_BOX_SCANNED]: SupportedShipBobWebhookTopics.WRO_BOX_SCANNED,
  wro_box_scanned: SupportedShipBobWebhookTopics.WRO_BOX_SCANNED,
  'wro box scanned': SupportedShipBobWebhookTopics.WRO_BOX_SCANNED,
  [SHIPBOB_API_WEBHOOK_TOPIC_WRO_BOX_STOWED]: SupportedShipBobWebhookTopics.WRO_BOX_STOWED,
  wro_box_stowed: SupportedShipBobWebhookTopics.WRO_BOX_STOWED,
  'wro box stowed': SupportedShipBobWebhookTopics.WRO_BOX_STOWED,
}

/**
 * Topic string sent to ShipBob when creating webhook subscriptions (`POST /2026-01/webhook`).
 */
export const shipBobWebhookTopicToApiTopic = (topic: SupportedShipBobWebhookTopics): string => {
  return API_TOPIC_BY_INTERNAL[topic]
}

/**
 * Resolves a topic from an inbound webhook delivery header or subscription row to Doss's internal enum.
 * Accepts `2026-01` (`order.shipped`, `wro.created`, …) and legacy / spaced forms.
 */
export const resolveShipBobWebhookTopic = (
  topic: string,
): SupportedShipBobWebhookTopics | undefined => {
  const normalized = topic.trim().toLowerCase()
  const fromInbound = INTERNAL_BY_INBOUND_TOPIC[normalized]
  if (fromInbound !== undefined) {
    return fromInbound
  }

  const trimmed = topic.trim()
  if (
    Object.values(SupportedShipBobWebhookTopics).includes(trimmed as SupportedShipBobWebhookTopics)
  ) {
    return trimmed as SupportedShipBobWebhookTopics
  }

  return undefined
}

/** Reads `shipbob-topic` or `x-webhook-topic` from webhook request headers (case-insensitive). */
export const getShipBobWebhookTopicFromHeaders = (
  headers: Record<string, string>,
): string | undefined => {
  const targetNames = ['shipbob-topic', 'x-webhook-topic']
  for (const canonicalName of targetNames) {
    const target = canonicalName.toLowerCase()
    for (const [key, value] of Object.entries(headers)) {
      if (key.toLowerCase() === target && value.trim() !== '') {
        return value.trim()
      }
    }
  }
  return undefined
}
